import { render, staticRenderFns } from "./bottom-sheet-events.vue?vue&type=template&id=5c08e78c"
import script from "./bottom-sheet-events.vue?vue&type=script&lang=js"
export * from "./bottom-sheet-events.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports